import classNames from 'classnames';
import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { remarkMark } from 'remark-mark-highlight';
import { commentList, commentListType } from './Comment.css';

export const MyList = ({ children, ...props }: any) => <div {...props}>{children}</div>;

const MarkDownRender = ({ ...props }: any) => {
  let markdown = props.children;
  if (markdown && typeof markdown === 'object' && Array.isArray(markdown)) {
    markdown = markdown.join('');
  }

  return (
    <div className={props.className}>
      <Markdown
        remarkPlugins={[remarkGfm, remarkMark]}
        components={{
          ul(props: any) {
            return renderList(props, 'disc');
          },
          ol(props: any) {
            return renderList(props, 'decimal');
          },
        }}
      >
        {markdown}
      </Markdown>
    </div>
  );
};

function renderList(props: any, type: string) {
  const { children, node, ...rest } = props;

  return (
    <MyList {...rest} className={classNames(commentList, commentListType[type])}>
      {children}
    </MyList>
  );
}

export default MarkDownRender;
